import { render } from "./HomePage.vue?vue&type=template&id=628df2bb&ts=true"
import script from "./HomePage.vue?vue&type=script&lang=ts"
export * from "./HomePage.vue?vue&type=script&lang=ts"

import exportComponent from "F:\\Programming_And_Stuff\\Programming\\Stella-Maris-53-VueJSOld\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__